export class History
{
    static push_url(url, title)
    {
        // set page title
        document.title = title;

        // push new url
        history.pushState({
            v: url
        }, title, url);

        // update return url for ISE
        if(document.body.dataset.ise === 'on')
        {
            const iseExit = document.body.querySelector('.ise.ise--exit');
            if(iseExit)
            {
                iseExit.href = iseExit.href.replace(/url=.*/, 'url=' + document.location.pathname);
            }
        }
    }

    static replace_url()
    {
        const data = {
            v: (document.documentURI && document.documentURI !== "undefined")
                ? document.documentURI
                : document.location.pathname
        };

        history.replaceState(data,'', data.v);
    }

    static add_event()
    {
        window.addEventListener('popstate',e =>
        {
            if(e.state && e.state.v)
            {
                document.location = e.state.v;
            }
        });
    }
}
